import React from "react";
import { BarChart, Bar, Cell, ResponsiveContainer, XAxis, YAxis, Tooltip } from 'recharts';
const AverageProjectValue = () => {
    const data = [
        { name: 'Partner 1', value: 400 },
        { name: 'Partner 2', value: 700 },
        { name: 'Partner 3', value: 200 },
    ];
    var tooltip;
    const CustomTooltip = ({ active, payload }) => {
        if (!active || !tooltip)    return null
        for (const bar of payload)
            if (bar.dataKey === tooltip)
                return <div>{ bar.name }<br/>{ bar.value.toFixed(2) }</div>
        return null
    }
    const COLORS = ['#ffa600', '#fa7a13', '#ff6361' , '#ca472f', '#bc5090'];

    return (<>
        <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="card card-radius">
                    <div className="header card-header custum-bg-warning rounded">
                        <h2 className="text-white">Average Project Value</h2>
                    </div>
                    <div className="body card-body-shadow">
                        <div className="row">
                            <div className="col-lg-12 col-md-6 col-sm-12 text-center">
                                <ResponsiveContainer width="100%" height={600}>
                                    <BarChart width={650} height={500} data={data}>
                                       
                                        <XAxis dataKey="name" />
                                        <YAxis />
                                        <Tooltip cursor={false} content={<CustomTooltip/>} />
                                        <Bar dataKey="value"  radius={[8, 8, 0, 0]}  onMouseOver={ () => tooltip="value"} >
                                            {
                                                data.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)
                                            }
                                        </Bar>
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default AverageProjectValue;